<template>
  <el-form :model="formData" :rules="ruleValidate" ref="dictionaryForm">
    <el-row >
      <el-col :span="11">
        <el-form-item class="mr5 ml5 mb10" prop="name">
          <el-input clearable v-model="formData.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item class="mr5 ml5 mb10" prop="value">
          <el-input clearable v-model="formData.value"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="2" class="tx-c" v-if="exchangeIndex > 0">
        <el-button icon="el-icon-minus" @click="removeItem"></el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>

export default {
  name: "exchangeItemForm",
  components: {
  },
  props: ['defualtData', 'exchangeIndex'],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      formData: {
        name: '',
        value: '',
      },
      ruleValidate: {
        name: [
          {required: true, message: '原始值不能为空', trigger: 'blur'}
        ],
        value: [
          {required: true, message: '显示值不能为空', trigger: 'blur'}
        ],
      },
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {},
  destroyed() {},
  methods: {
    getData(){
      return this.formData
    },
    removeItem(){
      this.$emit('removeItem')
    },
    getDefualtData(){
      this.formData = JSON.parse(JSON.stringify(this.defualtData))
    },
  },
  watch: {
    
  },
  filters: {}
};
</script>

<style scoped lang="less">
</style>
